import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Sparkles, Microscope } from 'lucide-react';
export function RevelationSection() {
  return <section className="py-14 md:py-24 px-6 bg-sage/10 relative overflow-hidden" data-id="element-189">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 opacity-30" data-id="element-190">
        <div className="absolute -top-40 -right-40 w-96 h-96 rounded-full bg-sage/20 blur-3xl" data-id="element-191"></div>
        <div className="absolute bottom-0 -left-20 w-72 h-72 rounded-full bg-gold/10 blur-3xl" data-id="element-192"></div>
      </div>

      <div className="max-w-4xl mx-auto" data-id="element-193">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} data-id="element-194">
          <div className="text-center mb-10 md:mb-16" data-id="element-195">
            <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-196">
              La Verdad Que Ocultan Las Grandes Marcas
            </h2>
            <p className="text-xl text-charcoal/80 max-w-2xl mx-auto" data-id="element-197">
              La piel no lee etiquetas de precios,{' '}
              <span className="font-bold text-gold" data-id="element-198">lee moléculas.</span>
            </p>
          </div>

          <div className="bg-white p-6 md:p-12 rounded-2xl shadow-xl border border-sage/20 mb-8 md:mb-12" data-id="element-199">
            <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-200">
              <div className="md:w-1/3 flex justify-center" data-id="element-201">
                <div className="w-32 h-32 rounded-full bg-cream flex items-center justify-center border-4 border-sage/30" data-id="element-202">
                  <Microscope className="w-16 h-16 text-sage" data-id="element-203" />
                </div>
              </div>
              <div className="md:w-2/3 space-y-4" data-id="element-204">
                <h3 className="text-2xl font-bold font-serif text-charcoal" data-id="element-205">
                  El Estudio de 2025
                </h3>
                <p className="text-lg text-charcoal/70 leading-relaxed" data-id="element-206">
                  Un estudio reciente confirma que el{' '}
                  <strong className="text-charcoal bg-gold/20 px-2 py-1 rounded" data-id="element-207">
                    85% de los ingredientes
                  </strong>{' '}
                  en cremas de lujo son rellenos, fragancias y conservantes que
                  no aportan nada a tu regeneración celular.
                </p>
              </div>
            </div>
          </div>

          <div className="space-y-6 md:space-y-8" data-id="element-208">
            <h3 className="text-2xl md:text-3xl font-bold text-center mb-6 md:mb-10" data-id="element-209">
              La Solución: Skin-Cycling Estratégico
            </h3>

            <div className="grid md:grid-cols-2 gap-6" data-id="element-210">
              <div className="flex gap-4 items-start" data-id="element-211">
                <div className="mt-1 bg-gold/20 p-2 rounded-full" data-id="element-212">
                  <Sparkles className="w-6 h-6 text-gold" data-id="element-213" />
                </div>
                <div data-id="element-214">
                  <h4 className="font-bold text-lg mb-2" data-id="element-215">Activos Potentes</h4>
                  <p className="text-charcoal/70" data-id="element-216">
                    Alternar noches de activos potentes de farmacia para
                    estimular la renovación celular.
                  </p>
                </div>
              </div>

              <div className="flex gap-4 items-start" data-id="element-217">
                <div className="mt-1 bg-sage/20 p-2 rounded-full" data-id="element-218">
                  <ShieldCheck className="w-6 h-6 text-sage" data-id="element-219" />
                </div>
                <div data-id="element-220">
                  <h4 className="font-bold text-lg mb-2" data-id="element-221">
                    Recuperación Profunda
                  </h4>
                  <p className="text-charcoal/70" data-id="element-222">
                    Noches dedicadas exclusivamente a reparar la barrera cutánea
                    y producir colágeno sin inflamarse.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-8 md:mt-12 text-center" data-id="element-223">
              <p className="text-xl font-serif italic text-charcoal/90 border-b border-gold/30 inline-block pb-2" data-id="element-224">
                Es ciencia pura, aplicada con precios de genérico.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}